import { Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { useState } from "react";
import {
  agentDossierColumns,
  dossierColumns,
} from "../lib/constants/dossierColumns";
import { useCurrentUser } from "../../../../lib/hooks/useCurrentUser";
import { Modal } from "@/components/v2";
import { Button, Card, CardFooter, Checkbox } from "@rumbledirect/ui";

interface ColumnsModalProps {
  visibleKeys: string[];
  setVisibleKeys: (keys: string[]) => void;
  remember?: boolean;
  setRemember?: (remember: boolean) => void;
}

export const DossiersColumnsModal = ({
  visibleKeys,
  setVisibleKeys,
  remember = false,
  setRemember,
}: ColumnsModalProps) => {
  const currentUser = useCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempSelectedKeys, setTempSelectedKeys] =
    useState<string[]>(visibleKeys);

  const hasAgentsPermission = currentUser?.permissions?.includes(
    "admin_rumble_agents_nav",
  );

  const columns = hasAgentsPermission ? agentDossierColumns : dossierColumns;

  const options = columns.map((col) => ({
    label: col.title as string,
    value: col.key as string,
  }));

  const handleOk = () => {
    setVisibleKeys(tempSelectedKeys);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        icon={<SettingOutlined />}
        onClick={() => setIsModalOpen(true)}
        variant="light"
      >
        Kolommen
      </Button>

      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)}>
        <Card title="Kolommen selecteren">
          <Space className="mb-4">
            <Button
              size="small"
              onClick={() =>
                setTempSelectedKeys(options.map((option) => option.value))
              }
            >
              Alles selecteren
            </Button>
            <Button size="small" onClick={() => setTempSelectedKeys([])}>
              Alles deselecteren
            </Button>
          </Space>

          <Space className="mb-4 border-b-2 pb-4 w-full border-gray-200">
            <Checkbox
              checked={remember}
              onChange={(e) => setRemember?.(e.target.checked)}
            >
              Onthoud deze selectie
            </Checkbox>
          </Space>

          <Checkbox.Group
            options={options}
            value={tempSelectedKeys}
            onChange={(checkedValues) =>
              setTempSelectedKeys(checkedValues as string[])
            }
            className="flex flex-col gap-2"
          />

          <CardFooter>
            <Button onClick={() => setIsModalOpen(false)}>Annuleren</Button>

            <Button type="primary" htmlType="submit" onClick={() => handleOk()}>
              Toepassen
            </Button>
          </CardFooter>
        </Card>
      </Modal>
    </>
  );
};
